<div class="container pb-3">
  <div class="top-logo">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="186.374"
      height="48.393"
      viewBox="0 0 186.374 48.393"
    >
      <g
        id="Group_11032"
        data-name="Group 11032"
        transform="translate(-142.996 -71)"
      >
        <g id="domii-logo-poster" transform="translate(207.275 76)">
          <path
            id="domii"
            d="M14.061,189.237a13.74,13.74,0,0,0,3.832-.528,14.017,14.017,0,0,0,3.419-1.5,3.6,3.6,0,0,0,3.125,1.7,3.651,3.651,0,0,0,1.429-.279,3.746,3.746,0,0,0,1.165-.763,3.46,3.46,0,0,0,1.061-2.538v-30.4a3.463,3.463,0,0,0-1.061-2.538,3.757,3.757,0,0,0-1.165-.762,3.8,3.8,0,0,0-2.859,0,3.757,3.757,0,0,0-1.165.762,3.463,3.463,0,0,0-1.061,2.538v8.041a13.933,13.933,0,0,0-6.721-1.7,13.581,13.581,0,0,0-5.439,1.1,14.277,14.277,0,0,0-4.465,3.008,14.427,14.427,0,0,0-3.037,4.446,13.755,13.755,0,0,0,0,10.872,14.208,14.208,0,0,0,3.037,4.446,14.41,14.41,0,0,0,4.465,2.993A13.58,13.58,0,0,0,14.061,189.237Zm0-7.307a6.689,6.689,0,0,1-4.746-1.937,6.8,6.8,0,0,1-1.444-2.127,6.65,6.65,0,0,1,0-5.209,6.847,6.847,0,0,1,1.444-2.113,6.8,6.8,0,0,1,7.31-1.437,6.8,6.8,0,0,1,2.108,1.349A6.646,6.646,0,0,1,20.782,175v.265a6.444,6.444,0,0,1-.53,2.6,6.937,6.937,0,0,1-1.43,2.127,6.475,6.475,0,0,1-2.122,1.423A6.741,6.741,0,0,1,14.061,181.929Zm30.62,7.307a13.653,13.653,0,0,0,5.468-1.1,14.053,14.053,0,0,0,7.458-7.439,13.924,13.924,0,0,0,0-10.872,14.341,14.341,0,0,0-3.007-4.446,14.109,14.109,0,0,0-4.451-3.008,14.065,14.065,0,0,0-10.907,0,14.3,14.3,0,0,0-7.5,7.454,13.746,13.746,0,0,0,0,10.872,14.193,14.193,0,0,0,3.036,4.446,14.41,14.41,0,0,0,4.465,2.993A13.58,13.58,0,0,0,44.681,189.237Zm0-7.307a6.689,6.689,0,0,1-4.746-1.937,6.814,6.814,0,0,1-1.444-2.127,6.651,6.651,0,0,1,0-5.209,6.86,6.86,0,0,1,1.444-2.113,6.689,6.689,0,0,1,4.746-1.937,6.752,6.752,0,0,1,2.638.513,6.467,6.467,0,0,1,2.122,1.423,6.985,6.985,0,0,1,1.43,2.113,6.659,6.659,0,0,1,0,5.209,6.937,6.937,0,0,1-1.43,2.127,6.467,6.467,0,0,1-2.122,1.423A6.738,6.738,0,0,1,44.681,181.929Zm51.048,6.984a3.467,3.467,0,0,0,1.385-.279,3.751,3.751,0,0,0,1.135-.748,3.419,3.419,0,0,0,.766-1.115,3.5,3.5,0,0,0,.28-1.409h0V172.539a13.748,13.748,0,0,0-.692-4.387,10.778,10.778,0,0,0-2-3.609,9.47,9.47,0,0,0-3.2-2.435,9.847,9.847,0,0,0-4.274-.9,12.222,12.222,0,0,0-4.392.822,14.219,14.219,0,0,0-3.92,2.259,9.712,9.712,0,0,0-7.281-3.081,7.6,7.6,0,0,0-2.919.557,9,9,0,0,0-2.476,1.526,3.363,3.363,0,0,0-1.268-1.5,3.485,3.485,0,0,0-1.946-.558,3.859,3.859,0,0,0-1.459.279,3.549,3.549,0,0,0-1.194.777,3.789,3.789,0,0,0-.8,1.16,3.375,3.375,0,0,0-.295,1.394h0V185.3a3.348,3.348,0,0,0,.295,1.409,3.867,3.867,0,0,0,.8,1.145,3.628,3.628,0,0,0,2.594,1.056,3.627,3.627,0,0,0,2.564-1.056,3.66,3.66,0,0,0,.782-1.145,3.5,3.5,0,0,0,.28-1.409h0V172.98a1.028,1.028,0,0,0,.03-.411c-.019-.117-.03-.186-.03-.205h0v-.147a2.9,2.9,0,0,1,.456-1.467,4.535,4.535,0,0,1,1.076-1.174,5.085,5.085,0,0,1,1.459-.777,4.923,4.923,0,0,1,1.607-.279,3.084,3.084,0,0,1,2.565,1.071,4.577,4.577,0,0,1,.914,2.773h0v13a3.217,3.217,0,0,0,.31,1.409,3.7,3.7,0,0,0,.81,1.115,3.847,3.847,0,0,0,1.179.748,3.768,3.768,0,0,0,1.445.279,3.473,3.473,0,0,0,1.385-.279,3.751,3.751,0,0,0,1.135-.748,3.419,3.419,0,0,0,.766-1.115,3.5,3.5,0,0,0,.28-1.409h0V172.422a2.992,2.992,0,0,1,.413-1.512,4.361,4.361,0,0,1,1.076-1.247,5.431,5.431,0,0,1,1.489-.837,4.692,4.692,0,0,1,1.65-.307,3.091,3.091,0,0,1,2.55,1.071,4.525,4.525,0,0,1,.929,2.773h0v13a3.217,3.217,0,0,0,.31,1.409,3.7,3.7,0,0,0,.81,1.115,3.842,3.842,0,0,0,1.18.748A3.761,3.761,0,0,0,95.728,188.914Zm10.958-30.108a3.832,3.832,0,0,0,1.518-.308,4.129,4.129,0,0,0,1.268-.837,3.855,3.855,0,0,0,1.164-2.758,3.757,3.757,0,0,0-.31-1.526,3.856,3.856,0,0,0-.855-1.232,4.129,4.129,0,0,0-1.268-.837,3.892,3.892,0,0,0-3.036,0,3.928,3.928,0,0,0-1.253.837,3.983,3.983,0,0,0-.841,1.232,3.88,3.88,0,0,0,0,3.037,3.895,3.895,0,0,0,2.093,2.083A3.829,3.829,0,0,0,106.687,158.806Zm.058,30.108a3.627,3.627,0,0,0,2.565-1.056,3.66,3.66,0,0,0,.782-1.145,3.5,3.5,0,0,0,.28-1.409V164.851a3.532,3.532,0,0,0-.28-1.394,3.866,3.866,0,0,0-.752-1.16,3.3,3.3,0,0,0-1.135-.777,3.568,3.568,0,0,0-1.4-.279,3.859,3.859,0,0,0-1.459.279,3.541,3.541,0,0,0-1.194.777,3.806,3.806,0,0,0-.8,1.16,3.388,3.388,0,0,0-.295,1.394V185.3a3.36,3.36,0,0,0,.295,1.409,3.885,3.885,0,0,0,.8,1.145,3.628,3.628,0,0,0,2.594,1.056Zm11.4-30.108a3.832,3.832,0,0,0,1.518-.308,4.129,4.129,0,0,0,1.268-.837A3.854,3.854,0,0,0,122.1,154.9a3.757,3.757,0,0,0-.309-1.526,3.856,3.856,0,0,0-.855-1.232,4.129,4.129,0,0,0-1.268-.837,3.892,3.892,0,0,0-3.036,0,3.935,3.935,0,0,0-2.094,2.069,3.88,3.88,0,0,0,0,3.037,3.895,3.895,0,0,0,2.094,2.083A3.829,3.829,0,0,0,118.146,158.806Zm.059,30.108a3.627,3.627,0,0,0,2.564-1.056,3.66,3.66,0,0,0,.782-1.145,3.5,3.5,0,0,0,.28-1.409V164.851a3.532,3.532,0,0,0-.28-1.394,3.851,3.851,0,0,0-.752-1.16,3.3,3.3,0,0,0-1.135-.777,3.568,3.568,0,0,0-1.4-.279,3.859,3.859,0,0,0-1.459.279,3.549,3.549,0,0,0-1.194.777,3.789,3.789,0,0,0-.8,1.16,3.376,3.376,0,0,0-.3,1.394V185.3a3.348,3.348,0,0,0,.3,1.409,3.867,3.867,0,0,0,.8,1.145,3.628,3.628,0,0,0,2.594,1.056Z"
            transform="translate(0 -151)"
            fill="#f75a72"
          />
        </g>
        <g
          id="Group_11031"
          data-name="Group 11031"
          transform="translate(-114.004 -58)"
        >
          <g
            id="Domii_Logo_White"
            data-name="Domii Logo_White"
            transform="translate(257 129)"
          >
            <path
              id="Combined-Shape"
              d="M31.684,25.3a.688.688,0,0,0-.6-.354H22.033l1.518-11.69a.7.7,0,0,0-.459-.734.69.69,0,0,0-.815.278L11.271,32.24a.7.7,0,0,0-.015.7.69.69,0,0,0,.6.357h8.916l-1.2,11.709a.7.7,0,0,0,.475.718.693.693,0,0,0,.806-.289L31.676,26a.7.7,0,0,0,.008-.7Z"
              transform="translate(2.353 2.629)"
              fill="#f75a72"
            />
            <path
              id="Path"
              d="M47.224,18.806a2.734,2.734,0,0,0-.18-.274l-.122-.155-.1-.11-.107-.109-.064-.061-.1-.086L25.8.716l-.126-.1a3.085,3.085,0,0,0-3.827.1L1.1,18.01l-.085.074-.133.128-.123.133-.04.047a3.171,3.171,0,0,0-.228.311l-.08.131a3.079,3.079,0,0,0-.355.972l-.031.209-.013.133L0,20.2c0,.048,0,.091,0,.132V44.562l0,.133a3.093,3.093,0,0,0,3.085,2.954H15.264l.133,0a3.091,3.091,0,0,0,2.954-3.084l-.006-.182-.013-.162-.018-.13a3.09,3.09,0,0,0-3.05-2.614H6.173V21.814L23.824,7.106,41.475,21.814v19.66h-9.09a3.087,3.087,0,0,0-3.08,2.877l-.007.183a3.093,3.093,0,0,0,3.087,3.115H44.562a3.088,3.088,0,0,0,3.087-3.087V20.313l0-.136L47.626,20l-.029-.189a3,3,0,0,0-.275-.82Z"
              transform="translate(0 0)"
              fill="#f75a72"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>

  <h2
    class="page-title"
    *ngIf="!feedbackSubmittedthanks && !feedbackSubmittedError"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="52"
      viewBox="0 0 69.762 62.108"
    >
      <g
        id="Group_11041"
        data-name="Group 11041"
        transform="translate(0 62.108)"
      >
        <path
          id="Path_1505"
          data-name="Path 1505"
          d="M12.8,65.954H26.579a8.134,8.134,0,0,0,8.166-8V38.9a8.025,8.025,0,0,0-8.166-8H18.753V28.014a11.482,11.482,0,0,1,8.677-10.548A6.975,6.975,0,0,0,32.193,8.79a6.887,6.887,0,0,0-6.635-4.934,8.54,8.54,0,0,0-2.042.34C12.458,7.6,4.972,17.126,4.972,28.185V57.958a7.455,7.455,0,0,0,7.826,8Z"
          transform="translate(35.017 -65.964)"
          fill="#e3e3e3"
        />
        <path
          id="Path_1506"
          data-name="Path 1506"
          d="M16.744,65.954H30.524a8.134,8.134,0,0,0,8.166-8V38.9a8.025,8.025,0,0,0-8.166-8H22.7V28.015a11.482,11.482,0,0,1,8.677-10.548A6.975,6.975,0,0,0,36.139,8.79,6.887,6.887,0,0,0,29.5,3.857a8.539,8.539,0,0,0-2.042.34C16.4,7.6,8.918,17.127,8.918,28.185V57.958a7.642,7.642,0,0,0,7.826,8Z"
          transform="translate(-8.909 -65.964)"
          fill="#e3e3e3"
        />
      </g>
    </svg>
    Please Submit your Feedback!
  </h2>
  <div class="box thankyou" *ngIf="feedbackSubmittedthanks">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="284.479"
      height="156.569"
      viewBox="0 0 284.479 156.569"
    >
      <g id="Group_11036" data-name="Group 11036" transform="translate(0)">
        <path
          id="Path_10804"
          data-name="Path 10804"
          d="M304.906,177.22a16.843,16.843,0,0,1,0,6.189,15.818,15.818,0,0,1,0-6.189Z"
          transform="translate(-86.154 -156.532)"
          fill="#e0e0e0"
        />
        <path
          id="Path_10805"
          data-name="Path 10805"
          d="M306.56,181.612a8.575,8.575,0,0,1,3.056-.287,8.48,8.48,0,0,1,3.056.287A15.434,15.434,0,0,1,306.56,181.612Z"
          transform="translate(-84.371 -152.825)"
          fill="#e0e0e0"
        />
        <path
          id="Path_10806"
          data-name="Path 10806"
          d="M305.016,188.778a15.912,15.912,0,0,1,0-6.208A16.96,16.96,0,0,1,305.016,188.778Z"
          transform="translate(-86.054 -151.663)"
          fill="#e0e0e0"
        />
        <path
          id="Path_10807"
          data-name="Path 10807"
          d="M308.5,185.243c-.115.1-.707-.4-1.318-1.108s-.974-1.394-.86-1.49.726.382,1.318,1.108S308.631,185.033,308.5,185.243Z"
          transform="translate(-84.608 -151.605)"
          fill="#e0e0e0"
        />
        <path
          id="Path_10808"
          data-name="Path 10808"
          d="M308.383,179c.115.134-.286.726-.917,1.356s-1.222,1.051-1.337.936.286-.726.917-1.356A3.556,3.556,0,0,1,308.383,179Z"
          transform="translate(-84.78 -154.912)"
          fill="#e0e0e0"
        />
        <g id="Group_10821" data-name="Group 10821">
          <ellipse
            id="Ellipse_67"
            data-name="Ellipse 67"
            cx="56.122"
            cy="56.122"
            rx="56.122"
            ry="56.122"
            transform="translate(84.634 44.326)"
            fill="#f75a72"
          />
          <path
            id="Path_10794"
            data-name="Path 10794"
            d="M300.372,205.52c.707.579-9.775,14.684-23.409,31.491l-8.275,10.033-1.136,1.372-1.2-1.243c-10.718-11-17.943-19.143-17.428-19.658s8.682,6.753,19.658,17.407l-2.315.236,8.1-10.14C288,218.1,299.644,204.941,300.372,205.52Z"
            transform="translate(-131.985 -128.76)"
            fill="#fff"
          />
          <path
            id="Path_10795"
            data-name="Path 10795"
            d="M292.86,208.845c1.672-5.9,9.325-5.316,9.325-5.316l-.193,4.094c-4.437-.772-7.181,4.416-7.181,4.416Z"
            transform="translate(-59.706 -74.035)"
            fill="#f75a72"
          />
          <path
            id="Path_10819"
            data-name="Path 10819"
            d="M302.185,208.845c-1.672-5.9-9.325-5.316-9.325-5.316l.193,4.094c4.437-.772,7.181,4.416,7.181,4.416Z"
            transform="translate(-17.706 -129.035)"
            fill="#f75a72"
          />
          <path
            id="Path_10796"
            data-name="Path 10796"
            d="M226.345,214.635c-1.651-5.9-9.325-5.338-9.325-5.338l.214,4.116c4.437-.772,7.181,4.416,7.181,4.416Z"
            transform="translate(-188.443 -74.435)"
            fill="#e0e0e0"
          />
          <path
            id="Path_10797"
            data-name="Path 10797"
            d="M264.478,179.4c8.9,2.7,14.427-7.546,14.427-7.546l-5.4-3.087c-2.658,6.281-11.533,5.552-11.533,5.552Z"
            transform="translate(-87.034 -140.77)"
            fill="#e0e0e0"
          />
          <path
            id="Path_10820"
            data-name="Path 10820"
            d="M276.4,179.4c-8.9,2.7-14.427-7.546-14.427-7.546l5.4-3.087c2.658,6.281,11.533,5.552,11.533,5.552Z"
            transform="translate(-47.034 -168.77)"
            fill="#e0e0e0"
          />
          <path
            id="Path_10798"
            data-name="Path 10798"
            d="M242.6,178.88c-4.137.45-4.63,5.638-4.63,5.638l2.765.322c0-3.044,3.794-4.287,3.794-4.287Z"
            transform="translate(-164.483 -109.207)"
            fill="#f75a72"
          />
          <path
            id="Path_10800"
            data-name="Path 10800"
            d="M254.215,156.755c.6-4.116-4.287-5.9-4.287-5.9l-1.008,2.615c2.958.75,3.237,4.716,3.237,4.716Z"
            transform="translate(-151.96 -141.254)"
            fill="#f75a72"
          />
          <path
            id="Path_10801"
            data-name="Path 10801"
            d="M203.734,186.021c-.729,6.431,7.8,8.017,7.8,8.017l1.543-4.287c-5.123-.472-5.852-6.431-5.852-6.431Z"
            transform="translate(-203.689 -104.129)"
            fill="#f75a72"
          />
          <path
            id="Path_10802"
            data-name="Path 10802"
            d="M293.339,176.644c4.159.236,5.488-4.8,5.488-4.8l-2.68-.772c-.493,3-4.437,3.623-4.437,3.623Z"
            transform="translate(-24.021 -138.14)"
            fill="#f75a72"
          />
          <path
            id="Path_10803"
            data-name="Path 10803"
            d="M306.72,181.753a9.624,9.624,0,0,1-3.43.322,9.517,9.517,0,0,1-3.43-.322A17.322,17.322,0,0,1,306.72,181.753Z"
            transform="translate(-73.7 -156.314)"
            fill="#e0e0e0"
          />
          <path
            id="Path_10809"
            data-name="Path 10809"
            d="M304.941,181.349c-.129.15-.772-.193-1.436-.75s-1.093-1.115-.986-1.243.75.193,1.415.729S305.048,181.22,304.941,181.349Z"
            transform="translate(-70.678 -158.696)"
            fill="#e0e0e0"
          />
          <path
            id="Path_10810"
            data-name="Path 10810"
            d="M304.727,182.461c.15.107-.257.772-.9,1.479s-1.265,1.158-1.393,1.029.257-.793.9-1.479S304.6,182.333,304.727,182.461Z"
            transform="translate(-70.785 -155.136)"
            fill="#e0e0e0"
          />
          <path
            id="Path_10811"
            data-name="Path 10811"
            d="M219.6,172.841a17.321,17.321,0,0,1-6.86,0,9.625,9.625,0,0,1,3.43-.321A9.52,9.52,0,0,1,219.6,172.841Z"
            transform="translate(-173.339 -166.524)"
            fill="#079039"
          />
          <g
            id="Group_10826"
            data-name="Group 10826"
            transform="translate(24.859 46.992)"
          >
            <path
              id="Path_10812"
              data-name="Path 10812"
              d="M217.823,168.3a17.856,17.856,0,0,1,0,6.967,17.858,17.858,0,0,1,0-6.967Z"
              transform="translate(-212.777 -168.3)"
              fill="#f75a72"
            />
            <path
              id="Path_10813"
              data-name="Path 10813"
              d="M219.45,172.733a17.32,17.32,0,0,1,6.86,0A17.322,17.322,0,0,1,219.45,172.733Z"
              transform="translate(-210.523 -163.622)"
              fill="#f75a72"
            />
            <path
              id="Path_10814"
              data-name="Path 10814"
              d="M217.933,180.606a17.75,17.75,0,0,1,0-6.946A17.749,17.749,0,0,1,217.933,180.606Z"
              transform="translate(-212.651 -162.17)"
              fill="#f75a72"
            />
            <path
              id="Path_10815"
              data-name="Path 10815"
              d="M221.659,176.565c-.15.129-.815-.429-1.479-1.243s-1.115-1.543-.965-1.672.793.45,1.479,1.243S221.788,176.565,221.659,176.565Z"
              transform="translate(-210.825 -162.202)"
              fill="#f75a72"
            />
            <path
              id="Path_10816"
              data-name="Path 10816"
              d="M221.551,170.125c.129.129-.343.815-1.029,1.522s-1.372,1.158-1.5,1.029.322-.793,1.029-1.5S221.423,169.91,221.551,170.125Z"
              transform="translate(-211.038 -166.266)"
              fill="#f75a72"
            />
            <path
              id="Path_10817"
              data-name="Path 10817"
              d="M217.813,172.454c-.107.129-.75-.193-1.415-.75s-1.115-1.115-.986-1.265.75.193,1.415.75S217.941,172.3,217.813,172.454Z"
              transform="translate(-215.167 -165.894)"
              fill="#f75a72"
            />
            <path
              id="Path_10818"
              data-name="Path 10818"
              d="M217.631,173.541c.129.129-.279.793-.9,1.5s-1.265,1.158-1.415,1.029.279-.793.9-1.479S217.481,173.412,217.631,173.541Z"
              transform="translate(-215.286 -162.329)"
              fill="#f75a72"
            />
          </g>
          <g
            id="Group_10827"
            data-name="Group 10827"
            transform="translate(214.859 76.992)"
          >
            <path
              id="Path_10812-2"
              data-name="Path 10812"
              d="M217.823,168.3a17.856,17.856,0,0,1,0,6.967,17.858,17.858,0,0,1,0-6.967Z"
              transform="translate(-212.777 -168.3)"
              fill="#f75a72"
            />
            <path
              id="Path_10813-2"
              data-name="Path 10813"
              d="M219.45,172.733a17.32,17.32,0,0,1,6.86,0A17.322,17.322,0,0,1,219.45,172.733Z"
              transform="translate(-210.523 -163.622)"
              fill="#f75a72"
            />
            <path
              id="Path_10814-2"
              data-name="Path 10814"
              d="M217.933,180.606a17.75,17.75,0,0,1,0-6.946A17.749,17.749,0,0,1,217.933,180.606Z"
              transform="translate(-212.651 -162.17)"
              fill="#f75a72"
            />
            <path
              id="Path_10815-2"
              data-name="Path 10815"
              d="M221.659,176.565c-.15.129-.815-.429-1.479-1.243s-1.115-1.543-.965-1.672.793.45,1.479,1.243S221.788,176.565,221.659,176.565Z"
              transform="translate(-210.825 -162.202)"
              fill="#f75a72"
            />
            <path
              id="Path_10816-2"
              data-name="Path 10816"
              d="M221.551,170.125c.129.129-.343.815-1.029,1.522s-1.372,1.158-1.5,1.029.322-.793,1.029-1.5S221.423,169.91,221.551,170.125Z"
              transform="translate(-211.038 -166.266)"
              fill="#f75a72"
            />
            <path
              id="Path_10817-2"
              data-name="Path 10817"
              d="M217.813,172.454c-.107.129-.75-.193-1.415-.75s-1.115-1.115-.986-1.265.75.193,1.415.75S217.941,172.3,217.813,172.454Z"
              transform="translate(-215.167 -165.894)"
              fill="#f75a72"
            />
            <path
              id="Path_10818-2"
              data-name="Path 10818"
              d="M217.631,173.541c.129.129-.279.793-.9,1.5s-1.265,1.158-1.415,1.029.279-.793.9-1.479S217.481,173.412,217.631,173.541Z"
              transform="translate(-215.286 -162.329)"
              fill="#f75a72"
            />
          </g>
        </g>
      </g>
    </svg>

    <h2>Thank you</h2>
    <p>Your feedback has been submitted. </p>
  </div>

  <div class="box thankyou" *ngIf="feedbackSubmittedError">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="284.479"
      height="156.569"
      viewBox="0 0 284.479 156.569"
    >
      <g id="Group_11036" data-name="Group 11036" transform="translate(0)">
        <path
          id="Path_10804"
          data-name="Path 10804"
          d="M304.906,177.22a16.843,16.843,0,0,1,0,6.189,15.818,15.818,0,0,1,0-6.189Z"
          transform="translate(-86.154 -156.532)"
          fill="#e0e0e0"
        />
        <path
          id="Path_10805"
          data-name="Path 10805"
          d="M306.56,181.612a8.575,8.575,0,0,1,3.056-.287,8.48,8.48,0,0,1,3.056.287A15.434,15.434,0,0,1,306.56,181.612Z"
          transform="translate(-84.371 -152.825)"
          fill="#e0e0e0"
        />
        <path
          id="Path_10806"
          data-name="Path 10806"
          d="M305.016,188.778a15.912,15.912,0,0,1,0-6.208A16.96,16.96,0,0,1,305.016,188.778Z"
          transform="translate(-86.054 -151.663)"
          fill="#e0e0e0"
        />
        <path
          id="Path_10807"
          data-name="Path 10807"
          d="M308.5,185.243c-.115.1-.707-.4-1.318-1.108s-.974-1.394-.86-1.49.726.382,1.318,1.108S308.631,185.033,308.5,185.243Z"
          transform="translate(-84.608 -151.605)"
          fill="#e0e0e0"
        />
        <path
          id="Path_10808"
          data-name="Path 10808"
          d="M308.383,179c.115.134-.286.726-.917,1.356s-1.222,1.051-1.337.936.286-.726.917-1.356A3.556,3.556,0,0,1,308.383,179Z"
          transform="translate(-84.78 -154.912)"
          fill="#e0e0e0"
        />
        <g id="Group_10821" data-name="Group 10821">
          <ellipse
            id="Ellipse_67"
            data-name="Ellipse 67"
            cx="56.122"
            cy="56.122"
            rx="56.122"
            ry="56.122"
            transform="translate(84.634 44.326)"
            fill="#f75a72"
          />
          <path
            id="Path_10794"
            data-name="Path 10794"
            d="M300.372,205.52c.707.579-9.775,14.684-23.409,31.491l-8.275,10.033-1.136,1.372-1.2-1.243c-10.718-11-17.943-19.143-17.428-19.658s8.682,6.753,19.658,17.407l-2.315.236,8.1-10.14C288,218.1,299.644,204.941,300.372,205.52Z"
            transform="translate(-131.985 -128.76)"
            fill="#fff"
          />
          <path
            id="Path_10795"
            data-name="Path 10795"
            d="M292.86,208.845c1.672-5.9,9.325-5.316,9.325-5.316l-.193,4.094c-4.437-.772-7.181,4.416-7.181,4.416Z"
            transform="translate(-59.706 -74.035)"
            fill="#f75a72"
          />
          <path
            id="Path_10819"
            data-name="Path 10819"
            d="M302.185,208.845c-1.672-5.9-9.325-5.316-9.325-5.316l.193,4.094c4.437-.772,7.181,4.416,7.181,4.416Z"
            transform="translate(-17.706 -129.035)"
            fill="#f75a72"
          />
          <path
            id="Path_10796"
            data-name="Path 10796"
            d="M226.345,214.635c-1.651-5.9-9.325-5.338-9.325-5.338l.214,4.116c4.437-.772,7.181,4.416,7.181,4.416Z"
            transform="translate(-188.443 -74.435)"
            fill="#e0e0e0"
          />
          <path
            id="Path_10797"
            data-name="Path 10797"
            d="M264.478,179.4c8.9,2.7,14.427-7.546,14.427-7.546l-5.4-3.087c-2.658,6.281-11.533,5.552-11.533,5.552Z"
            transform="translate(-87.034 -140.77)"
            fill="#e0e0e0"
          />
          <path
            id="Path_10820"
            data-name="Path 10820"
            d="M276.4,179.4c-8.9,2.7-14.427-7.546-14.427-7.546l5.4-3.087c2.658,6.281,11.533,5.552,11.533,5.552Z"
            transform="translate(-47.034 -168.77)"
            fill="#e0e0e0"
          />
          <path
            id="Path_10798"
            data-name="Path 10798"
            d="M242.6,178.88c-4.137.45-4.63,5.638-4.63,5.638l2.765.322c0-3.044,3.794-4.287,3.794-4.287Z"
            transform="translate(-164.483 -109.207)"
            fill="#f75a72"
          />
          <path
            id="Path_10800"
            data-name="Path 10800"
            d="M254.215,156.755c.6-4.116-4.287-5.9-4.287-5.9l-1.008,2.615c2.958.75,3.237,4.716,3.237,4.716Z"
            transform="translate(-151.96 -141.254)"
            fill="#f75a72"
          />
          <path
            id="Path_10801"
            data-name="Path 10801"
            d="M203.734,186.021c-.729,6.431,7.8,8.017,7.8,8.017l1.543-4.287c-5.123-.472-5.852-6.431-5.852-6.431Z"
            transform="translate(-203.689 -104.129)"
            fill="#f75a72"
          />
          <path
            id="Path_10802"
            data-name="Path 10802"
            d="M293.339,176.644c4.159.236,5.488-4.8,5.488-4.8l-2.68-.772c-.493,3-4.437,3.623-4.437,3.623Z"
            transform="translate(-24.021 -138.14)"
            fill="#f75a72"
          />
          <path
            id="Path_10803"
            data-name="Path 10803"
            d="M306.72,181.753a9.624,9.624,0,0,1-3.43.322,9.517,9.517,0,0,1-3.43-.322A17.322,17.322,0,0,1,306.72,181.753Z"
            transform="translate(-73.7 -156.314)"
            fill="#e0e0e0"
          />
          <path
            id="Path_10809"
            data-name="Path 10809"
            d="M304.941,181.349c-.129.15-.772-.193-1.436-.75s-1.093-1.115-.986-1.243.75.193,1.415.729S305.048,181.22,304.941,181.349Z"
            transform="translate(-70.678 -158.696)"
            fill="#e0e0e0"
          />
          <path
            id="Path_10810"
            data-name="Path 10810"
            d="M304.727,182.461c.15.107-.257.772-.9,1.479s-1.265,1.158-1.393,1.029.257-.793.9-1.479S304.6,182.333,304.727,182.461Z"
            transform="translate(-70.785 -155.136)"
            fill="#e0e0e0"
          />
          <path
            id="Path_10811"
            data-name="Path 10811"
            d="M219.6,172.841a17.321,17.321,0,0,1-6.86,0,9.625,9.625,0,0,1,3.43-.321A9.52,9.52,0,0,1,219.6,172.841Z"
            transform="translate(-173.339 -166.524)"
            fill="#079039"
          />
          <g
            id="Group_10826"
            data-name="Group 10826"
            transform="translate(24.859 46.992)"
          >
            <path
              id="Path_10812"
              data-name="Path 10812"
              d="M217.823,168.3a17.856,17.856,0,0,1,0,6.967,17.858,17.858,0,0,1,0-6.967Z"
              transform="translate(-212.777 -168.3)"
              fill="#f75a72"
            />
            <path
              id="Path_10813"
              data-name="Path 10813"
              d="M219.45,172.733a17.32,17.32,0,0,1,6.86,0A17.322,17.322,0,0,1,219.45,172.733Z"
              transform="translate(-210.523 -163.622)"
              fill="#f75a72"
            />
            <path
              id="Path_10814"
              data-name="Path 10814"
              d="M217.933,180.606a17.75,17.75,0,0,1,0-6.946A17.749,17.749,0,0,1,217.933,180.606Z"
              transform="translate(-212.651 -162.17)"
              fill="#f75a72"
            />
            <path
              id="Path_10815"
              data-name="Path 10815"
              d="M221.659,176.565c-.15.129-.815-.429-1.479-1.243s-1.115-1.543-.965-1.672.793.45,1.479,1.243S221.788,176.565,221.659,176.565Z"
              transform="translate(-210.825 -162.202)"
              fill="#f75a72"
            />
            <path
              id="Path_10816"
              data-name="Path 10816"
              d="M221.551,170.125c.129.129-.343.815-1.029,1.522s-1.372,1.158-1.5,1.029.322-.793,1.029-1.5S221.423,169.91,221.551,170.125Z"
              transform="translate(-211.038 -166.266)"
              fill="#f75a72"
            />
            <path
              id="Path_10817"
              data-name="Path 10817"
              d="M217.813,172.454c-.107.129-.75-.193-1.415-.75s-1.115-1.115-.986-1.265.75.193,1.415.75S217.941,172.3,217.813,172.454Z"
              transform="translate(-215.167 -165.894)"
              fill="#f75a72"
            />
            <path
              id="Path_10818"
              data-name="Path 10818"
              d="M217.631,173.541c.129.129-.279.793-.9,1.5s-1.265,1.158-1.415,1.029.279-.793.9-1.479S217.481,173.412,217.631,173.541Z"
              transform="translate(-215.286 -162.329)"
              fill="#f75a72"
            />
          </g>
          <g
            id="Group_10827"
            data-name="Group 10827"
            transform="translate(214.859 76.992)"
          >
            <path
              id="Path_10812-2"
              data-name="Path 10812"
              d="M217.823,168.3a17.856,17.856,0,0,1,0,6.967,17.858,17.858,0,0,1,0-6.967Z"
              transform="translate(-212.777 -168.3)"
              fill="#f75a72"
            />
            <path
              id="Path_10813-2"
              data-name="Path 10813"
              d="M219.45,172.733a17.32,17.32,0,0,1,6.86,0A17.322,17.322,0,0,1,219.45,172.733Z"
              transform="translate(-210.523 -163.622)"
              fill="#f75a72"
            />
            <path
              id="Path_10814-2"
              data-name="Path 10814"
              d="M217.933,180.606a17.75,17.75,0,0,1,0-6.946A17.749,17.749,0,0,1,217.933,180.606Z"
              transform="translate(-212.651 -162.17)"
              fill="#f75a72"
            />
            <path
              id="Path_10815-2"
              data-name="Path 10815"
              d="M221.659,176.565c-.15.129-.815-.429-1.479-1.243s-1.115-1.543-.965-1.672.793.45,1.479,1.243S221.788,176.565,221.659,176.565Z"
              transform="translate(-210.825 -162.202)"
              fill="#f75a72"
            />
            <path
              id="Path_10816-2"
              data-name="Path 10816"
              d="M221.551,170.125c.129.129-.343.815-1.029,1.522s-1.372,1.158-1.5,1.029.322-.793,1.029-1.5S221.423,169.91,221.551,170.125Z"
              transform="translate(-211.038 -166.266)"
              fill="#f75a72"
            />
            <path
              id="Path_10817-2"
              data-name="Path 10817"
              d="M217.813,172.454c-.107.129-.75-.193-1.415-.75s-1.115-1.115-.986-1.265.75.193,1.415.75S217.941,172.3,217.813,172.454Z"
              transform="translate(-215.167 -165.894)"
              fill="#f75a72"
            />
            <path
              id="Path_10818-2"
              data-name="Path 10818"
              d="M217.631,173.541c.129.129-.279.793-.9,1.5s-1.265,1.158-1.415,1.029.279-.793.9-1.479S217.481,173.412,217.631,173.541Z"
              transform="translate(-215.286 -162.329)"
              fill="#f75a72"
            />
          </g>
        </g>
      </g>
    </svg>

    <h2 *ngIf="!feedbackAlredaySubmitted">Sorry!</h2>
    <h2 *ngIf="feedbackAlredaySubmitted">Thank you!</h2>
    <p>{{ errorMessage }}</p>
  </div>
  <div class="box" *ngIf="!feedbackSubmittedthanks && !feedbackSubmittedError">
    <div class="pink-box">
      <p [innerHtml]="feedback?.testimony?.content1"></p>

      <p class="profile_imagebox">
        <img [src]="feedback?.picture" alt="profileimage" />
        {{ feedback?.firstName }} {{ feedback?.lastName }}
      </p>
    </div>
    <div class="white-box">
      <div [innerHtml]="feedback?.testimony?.content2"></div>
      <form class="mt-4" [formGroup]="testimonialForm">
      
        <div class="form-row">
          <div class="col mt-4">
            <textarea
              class="form-control"
              cols="4"
              rows="4"
              formControlName="testimonialText"
              [placeholder]="feedback?.testimony?.placeHolder"
            ></textarea>
          </div>
        </div>

        <div class="form-row mt-4">
          <div class="col-md-6">
            <label for="inputEmail4">Name</label>
            <input
              type="text"
              class="form-control"
              placeholder="eg. Johnny Ramirez"
              formControlName="name"
            />
          </div>
          <div class="col-md-6">
            <label for="inputEmail5">City <small>(Optional)</small></label>
            <input
              type="text"
              class="form-control"
              placeholder="eg. Boston"
              formControlName="townCity"
            />
            <input
              style="display: none"
              type="text"
              class="form-control"
              formControlName="code"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="col mt-4 text-right">
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="!testimonialForm.valid"
              (click)="onSaveClick()"
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div style="height: 170px"></div>
<app-footer></app-footer>